// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".clear-keyword-review-date[data-v-1f775f6a]{position:absolute;top:2px;left:120px}", ""]);
// Exports
module.exports = exports;
